export default __webpack_public_path__ + "static/media/6.328b7b0f.jpg";